import { render, staticRenderFns } from "./ProjectPartsListDetailDialog.vue?vue&type=template&id=4449f4af&scoped=true&lang=pug&"
import script from "./ProjectPartsListDetailDialog.vue?vue&type=script&lang=ts&"
export * from "./ProjectPartsListDetailDialog.vue?vue&type=script&lang=ts&"
import style0 from "./ProjectPartsListDetailDialog.vue?vue&type=style&index=0&id=4449f4af&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4449f4af",
  null
  
)

export default component.exports